// Function in this file take `supabaseClient` as a parameter and can therefore be used client and server side
import { SupabaseClient } from '@supabase/supabase-js';

import { EVENT_INDEX_PAGE_SIZE } from '@data/constants';
import { getEventList } from '@data/supabase/getEventList';
import { FilterQueryArguments } from '@interfaces';

interface GetEventDataParams {
	supabaseClient: SupabaseClient;
	queryArguments: FilterQueryArguments;
	pageNumber: number;
}

export async function getEventData({
	supabaseClient,
	queryArguments,
	pageNumber,
}: GetEventDataParams) {
	// Determine pagination range
	const rangeFrom = (pageNumber - 1) * EVENT_INDEX_PAGE_SIZE;
	const rangeTo = pageNumber * EVENT_INDEX_PAGE_SIZE - 1;

	const { events, count } = await getEventList({
		options: {
			dateFrom: queryArguments.dateFrom,
			dateTo: queryArguments.dateTo,
			excludeDice: true,
			range: {
				from: rangeFrom,
				to: rangeTo,
			},
			type: queryArguments.type,
			venues: queryArguments.venue ? [queryArguments.venue] : undefined,
			genres: queryArguments.genre ? [queryArguments.genre] : undefined,
		},
		supabaseClient,
	});

	let hasNextPage = false;

	if (typeof count === 'number') {
		hasNextPage = count > pageNumber * EVENT_INDEX_PAGE_SIZE;
	}

	return {
		events,
		pageNumber,
		hasNextPage,
	};
}
